import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = ["development", "test"].includes(import.meta.env.RAILS_ENV) ? true : false;
window.Stimulus = application;

export { application };
